import styled from 'styled-components';

export const CountryModal = styled.div`
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000099;
  padding: 10px 0;

  .modal-content {
    margin: auto;
    padding: 20px 40px;
    border: 1px solid #888;
    background-color: black;

    p:hover {
      background-color: #d4d6d720;
    }

    a {
      color: white;
    }
  }
`;
